<template>
  <div class="app-container">
    <!-- Skip Navigation Link -->
    <a href="#main-content" class="skip-link">ข้ามไปยังเนื้อหาหลัก</a>
    
    <!-- Header/Navbar (hide on admin routes) -->
    <AppHeader v-if="!isAdminRoute" />
    
    <main id="main-content" class="main-content" :class="{ 'admin-main': isAdminRoute }" tabindex="-1">
      <router-view></router-view>
    </main>
    
    <!-- Footer (hide on admin routes) -->
    <AppFooter v-if="!isAdminRoute" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

const route = useRoute();
const isAdminRoute = computed(() => route.path.startsWith('/admin'));
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* Gradient สบายตา: จากขาวไป cream อ่อน พร้อม hint สีอ่อน */
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    #fefbf7 25%,
    #faf8f3 50%,
    #f5f2eb 75%,
    #f0ede5 100%
  );
  position: relative;
}

.app-container::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  /* Radial gradient overlay อ่อนมาก ๆ เพื่อความลึกและนุ่มนวล */
  background: 
    radial-gradient(circle at 20% 50%, rgba(133, 94, 66, 0.03) 0%, transparent 60%),
    radial-gradient(circle at 80% 80%, rgba(212, 165, 116, 0.04) 0%, transparent 60%),
    radial-gradient(circle at 50% 20%, rgba(250, 248, 243, 0.5) 0%, transparent 40%);
  animation: heroPulse 10s ease-in-out infinite;
  z-index: 0;
}

@keyframes heroPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

.main-content {
  flex: 1;
  position: relative;
  z-index: 1;
}

.main-content.admin-main {
  display: flex;
  flex-direction: column;
}

/* Skip Navigation Link */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 4px;
  z-index: 1000;
  font-weight: 500;
  transition: top 0.2s ease;
}

.skip-link:focus {
  top: 6px;
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
</style>
